
import { en } from './en';
import { french } from './fr';
import { ResourcesType } from './types';

export const resources: ResourcesType = {
  en: {
    translation: en.translation
  },
  fr: {
    translation: french.translation
  }
};

// Export translations for use in LanguageContext
export const translations = resources;
